module.exports = __webpack_public_path__ + "static/media/S1N9.24a84678.svg";